import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';
import getImage from './../../../ClinicHistory/ClinicEvent/components/PdfReports/GetImage';
import ReportsAPI from './../../api/reports_api';
import { formatNumber } from '../../../Utils/Money';

const DetailedSurchargesPDF = async (obj, numFacTer) => {
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };
    //const city = obj.profile.direccion.id_ciudad;
    const city = sessionStorage.getItem('id_ciudad');
    const getCity = await ReportsAPI.loadCity(city);
    let cityReport= getCity.length > 0 ? getCity[0].ciunom : ' ';

    const getRandomInt = (min, max) => {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let randomReport = getRandomInt(110, 1);
    let itemBodyFontSize = 7;

    //Tabla de Contenido
    let itemBody = [
        [
            {
                text: "Primer Apellido",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Segundo Apellido",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Primer Nombre",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Segundo Nombre",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Número de Documento",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Tipo de Documento",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Fecha de Atención",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Codigo de Validacion",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Codigo de Autorización",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Servicio",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Cantidad",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Costo",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Copago",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Neto",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            }
        ],
    ];

    let itemArr = ["", "", "", "", "","", "", "", "", "","","","",""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
        const element = obj.items[index];
        itemBody.push([
            { text: element.apellido1, alignment: "center"  },
            { text: element.apellido2, alignment: "center"  },
            { text: element.primerNombre, alignment: "center"  },
            { text: element.segundoNombre, alignment: "center"  },
            { text: element.num_documento, alignment: "center"  },
            { text: element.tip_documento, alignment: "center"  },
            { text: element.fecha_atencion, alignment: "center"  },
            { text: element.codigo_validacion, alignment: "center"  },
            { text: element.codigo_autorizacion, alignment: "center"  },
            { text: element.servicio, alignment: "center"  },
            { text: element.cantidad, alignment: "center"  },
            { text: '$' + formatNumber(element.costo), alignment: "center"  },
            { text: '$' + formatNumber(element.copago), alignment: "center"  },
            { text: '$' + formatNumber(element.neto), alignment: "center"  },
        ]);
    }

    let widthsTable = ['auto','auto','auto','auto','auto','auto','auto','auto','auto','*','auto','auto','auto','auto'];

    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "landscape",
        info: {
            title: obj.title,
            author: "",
        },

        content: [
            {

                columns: [
                    {
                        width: 200,
                        columns: [
                            {
                                image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                                fit: [180, 90],
                            },
                        ],
                    },
                    {
                        width: "auto",
                        text: [
                            {
                                text: obj.profile.nombre + "\n" +
                                    "NIT:" + obj.profile.nit + "\n" +
                                    obj.profile.direccion.direccion + "\n"
                                    + obj.profile.telefono1 + "\n" +
                                    obj.profile.email
                            },
                        ],
                        alignment: "center"
                    },
                    {
                        text: [
                            {
                                text: obj.title,
                                bold: true,
                                width: "auto",
                                alignment: "right",
                                lineHeight: 1.2,
                                fontSize: 15,
                            },
                            {
                                text: "\n\n",
                                bold: false,
                                width: "auto",
                                alignment: "right",
                                lineHeight: 1.2,
                                fontSize: 15,
                            },
                            {
                                text: numFacTer != null && numFacTer != undefined ? numFacTer : "",
                                bold: true,
                                width: "auto",
                                alignment: "right",
                                lineHeight: 1.2,
                                fontSize: 18,
                            },
                        ]
                    },
                ],
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: widthsTable,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 5, 0, 0],
                fontSize: itemBodyFontSize,
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default DetailedSurchargesPDF;